module.exports = __webpack_public_path__ + "static/media/Logo-Final.c8d8c752.svg";